import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../../../ui/dialog";
import { Button } from "../../../../ui/button";
import { Alert, AlertDescription } from "../../../../ui/alert";
import { 
  AlertTriangle,
} from "lucide-react";

interface ValidationErrorModalProps {
  visible: boolean;
  onClose: () => void;
  validationErrors: string[];
}

const ValidationErrorModal: React.FC<ValidationErrorModalProps> = ({
  visible,
  onClose,
  validationErrors,
}) => {
  return (
    <Dialog open={visible} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-2xl" style={{ zIndex: 9999 }}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-600">
            <AlertTriangle className="w-5 h-5" />
            Unable to Save
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-6">
          <Alert className="border-red-200 bg-red-50">
            <AlertTriangle className="h-4 w-4 text-red-600" />
            <AlertDescription className="text-red-800">
              <div className="font-gc-med">Validation Errors Found</div>
              <div className="text-sm mt-1">Please resolve the following issues before saving:</div>
            </AlertDescription>
          </Alert>

          <div>
            <h4 className="text-sm font-gc-med text-red-600 mb-4">
              Issues to Resolve:
            </h4>
            
            <div className="max-h-[400px] overflow-y-auto space-y-2">
              {validationErrors.map((error, index) => (
                <div 
                  key={index}
                  className="flex items-start gap-2 p-3 border-b border-border last:border-b-0"
                >
                  <AlertTriangle className="w-4 h-4 text-red-600 flex-shrink-0 mt-0.5" />
                  <p className="text-sm text-foreground leading-relaxed">
                    {error}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="p-3 bg-red-50 border border-red-200 rounded-md">
            <p className="text-xs text-muted-foreground">
              <span className="font-gc-med">Tip:</span> Nodes with red outlines indicate validation errors. 
              Fix these issues and try saving again.
            </p>
          </div>
        </div>
        
        <DialogFooter>
          <Button 
            onClick={onClose}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            OK
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ValidationErrorModal; 